import React from "react";
import "./checkbox.scss";

export interface CheckboxProps {
  isSelected: boolean;
  onSelect: () => void;
  isDisabled?: boolean;
  name?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ isSelected, onSelect, isDisabled, name }) => {
  const modifierClasses = [];

  if (isSelected) {
    modifierClasses.push("c-checkbox--selected");
  }

  if (isDisabled) {
    modifierClasses.push("c-checkbox--disabled");
  }

  return (
    <div
      data-testid="checkbox-test-id"
      className={`c-checkbox ${modifierClasses.join(" ")}`}
      onClick={() => !isDisabled && onSelect()}
      role="checkbox"
      aria-checked={isSelected}
      {...(name ? { name } : {})}
    >
      {isSelected && <img src={require("../../../assets/icons/check-white-icn.svg")} alt="checkmark" />}
    </div>
  );
};
